export default "__VITE_ASSET__C7m_MXGS__"